import { productListStyles as styles } from "@dillon/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import { colorStrings, mediaQueriesBP } from "@dillon/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.lineInnerContainer = {
    gap: 10,
}

styles.imageWrapper = {
    css: css`
    @media print {
        max-height: 83px;
        max-width: 83px;
    }
    width: 100%;
    min-width: 0;
    flex-direction: column;
`,
}

styles.linkWrappingImage = {
    css: css`
        width: 100%;
    `
}

styles.img = {
    css: css`
        height: auto;
        width: 100%;
    `
}

styles.imageGridItem = {
    width: [3, 3, 2, 2, 1],
    printWidth: 1,
}

styles.descriptionGridItem = {
    width: [8, 8, 4, 4, 4],
    printWidth: 6,
    css: css`
        flex-direction: column;
    `,
}

styles.accordionHeader = {
    css: css`
        button {
            background-color: transparent;
            border: none;
            align-items: flex-start;
        }
    `,
}

styles.accordionPanel = {
    css: css`
        border: none;
        padding-bottom: 0px;

        ${mediaQueriesBP.minMD} {
            padding-inline: 40px 0;
        }

        &:not([hidden]) {
            margin-top: 20px;
            border-top: 1px solid ${getColor(colorStrings.commonGlobalGray03)};
        }

        & > div:last-child {
            border-bottom: none;
        }
    `,
}